import { IconComponentProps } from '@nexelem/icons';
import { ProLightIndustryWindows } from '@nexelem/icons/ProLightIndustryWindows';
import { ProLightLeftRight } from '@nexelem/icons/ProLightLeftRight';
import { ProLightBoxTaped } from '@nexelem/icons/ProLightBoxTaped';
import { ProLightTruck } from '@nexelem/icons/ProLightTruck';
import { ProLightLocationDot } from '@nexelem/icons/ProLightLocationDot';
import { FC } from 'react';
import { ProLightCartShopping } from '@nexelem/icons/ProLightCartShopping';

const map = new Map([
  ['Production', ProLightIndustryWindows],
  ['Transport', ProLightLeftRight],
  ['Packaging', ProLightBoxTaped],
  ['Delivery', ProLightTruck],
  ['Supply', ProLightLocationDot],
  ['Order', ProLightCartShopping],
]);
const defaultIcon = () => null;
export const getTaskTypeIcon = (taskType: string): FC<IconComponentProps> | undefined =>
  map.get(taskType) || defaultIcon;
